export default (element: HTMLElement) => {
  if (!(element instanceof HTMLButtonElement)) {
    console.error('copyToClipboard component must be used on a button element');
    return;
  }

  const targetSelector = element.dataset.targetSelector;
  if (!targetSelector) {
    console.error(
      'Missing data-target-selector attribute in copyToClipboard component',
    );
    return;
  }

  const targetElement = document.querySelector<
    HTMLInputElement | HTMLTextAreaElement
  >(targetSelector);
  if (!targetElement) {
    console.error(`Target element not found with selector: ${targetSelector}`);
    return;
  }

  const originalHtml = element.innerHTML;

  element.addEventListener('click', async () => {
    try {
      const textToCopy = targetElement.value;

      await navigator.clipboard.writeText(textToCopy);

      // Visual feedback
      element.textContent = 'Zkopírováno!';
      element.disabled = true;

      setTimeout(() => {
        element.innerHTML = originalHtml;
        element.disabled = false;
      }, 2000);
    } catch (error) {
      console.error('Failed to copy to clipboard:', error);
      element.textContent = 'Chyba při kopírování';

      setTimeout(() => {
        element.innerHTML = originalHtml;
      }, 2000);
    }
  });
};
